<template>
<div>

  <section class="content">
    <!-- Default box -->
    <div class="info-box"  v-if="canAccess('branch-view-any')">
      <div class="box-header with-border">
        <h3 class="box-title">Branch List</h3>
        
        <div class="box-tools">
          <a :href="`${this.$axios.defaults.baseURL}/branch/export/excel`" class="btn btn-box-tool">
            <i class="fa fa-file-excel-o"></i> Download Excel
          </a>
          <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('branch-create')">
            <i class="fa fa-plus"></i> Add New
          </button>
        </div>

      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-sm-6 col-xs-6">
            <label>
              <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <div class="col-sm-6 col-xs-6">
            <div class="input-group pull-right input-group-sm" style="width: 150px;">
              <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

              <div class="input-group-btn">
                <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
        <table class="table table-sm table-bordered table-hover">
          <thead style="background-color: #d6dddd;">
            <tr>
              <th class="hidden-xs">Sr. No.</th>
              <th>Name </th>
              <th>Code </th>
              <th class="hidden-xs">Phone </th>
              <th class="hidden-xs">City</th>
              <th class="hidden-xs">State</th>
              <th class="hidden-xs">Opening Date</th>
              <th class="hidden-xs">Status</th>
              <th>Action</th>

              <!-- <th v-if="$gate.isAdmin()">Status</th>
              <th>Image</th>
              <th v-if="$gate.isAdmin()">Modify</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows.data" :key="index">
              <td class="hidden-xs">{{ (index + pagination.from) }}</td>
              <td>{{ row.name }}</td>
              <td>{{ row.branchCode }}</td>
              <td class="hidden-xs">{{ row.phone }}</td>
              <td class="hidden-xs">{{ row.city }}</td>
              <td class="hidden-xs">{{ row.state.name }}</td>
              <td class="hidden-xs">{{ row.openingDate | myDate }}</td>
              <td class="hidden-xs">
                <div v-if="row.status == 'active'">
                  <span class="label label-success">Active</span>
                </div>
                <div v-else>
                  <span class="label label-danger">InActive</span>
                </div>
              </td>
              <td>
                <div class="btn-group">
                  <button
                    v-if="canAccess('branch-view')"
                    type="button"
                    @click="viewModal(row)"
                    class="btn btn-info btn-xs"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                  <button
                    v-if="canAccess('branch-update')"
                    @click="editModal(row)"
                    class="btn btn-success btn-xs"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
              
      </div>
      <!-- /.box-body -->
      <div class="box-footer clearfix" v-if="pagination.current_page > 0">
        <div class="row">
          <div class="col-sm-4">
            Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
          </div>
          <div class="col-sm-8">
            <ul class="pagination pagination-sm no-margin pull-right">
              <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
              <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

              <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
              <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
              <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
              <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
              <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
              <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
              <li><a href="#">...</a></li>
              
              <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
              <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
              <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

              <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
              <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- /.box -->
  </section>
        
    <div class="modal fade" id="newModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-aqua">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 v-show="!editMode" class="modal-title">Add New</h4>
            <h4 v-show="editMode" class="modal-title">Update</h4>
          </div>
          <form @submit.prevent="editMode ? updateBranch() : createBranch()">
            <div class="modal-body">
              <!-- right column -->
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-6">
                        <!-- text input -->
                        <div class="form-group">
                          <label>Branch Name</label>
                          <input
                            v-model="form.name"
                            type="text"
                            name="name"
                            class="form-control input-sm"
                            :class="{ 'is-invalid': form.errors.has('name') }"
                          />
                          <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Opening Date <span class="red">*</span></label
                          >
                          <input
                            v-model="form.openingDate"
                            type="date"
                            name="openingDate"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('openingDate'),
                            }"
                          />
                          <has-error
                            :form="form"
                            field="openingDate"
                          ></has-error>
                        </div>

                        <div class="form-group">
                          <label>Address</label>
                          <input
                            v-model="form.address"
                            type="text"
                            name="address"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('address'),
                            }"
                          />
                          <has-error :form="form" field="address"></has-error>
                        </div>
                        <div class="form-group">
                          <label>City<span class="red">*</span></label>
                          <input
                            v-model="form.city"
                            type="text"
                            name="city"
                            class="form-control input-sm"
                            :class="{ 'is-invalid': form.errors.has('city') }"
                          />
                          <has-error :form="form" field="city"></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Select State <span class="red">*</span></label
                          >
                          <select
                            v-model="form.state_id"
                            name="state_id"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('state_id'),
                            }"
                          >
                            <option v-if="!form.state_id" selected value="">
                              Select State
                            </option>
                            <option
                              :value="stat.id"
                              v-for="stat in states"
                              :key="stat.id"
                            >
                              {{ stat.name }}
                            </option>
                          </select>
                          <has-error
                            :form="form"
                            field="state_id"
                          ></has-error>
                        </div>
                        <div class="form-group">
                          <label>Country <span class="red">*</span></label>
                          <input
                            v-model="form.country"
                            type="text"
                            name="country"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('country'),
                            }"
                            readonly
                          />
                          <has-error :form="form" field="country"></has-error>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>Pincode <span class="red">*</span></label>
                          <input
                            v-model="form.pin"
                            type="text"
                            name="pin"
                            class="form-control input-sm"
                            :class="{ 'is-invalid': form.errors.has('pin') }"
                          />
                          <has-error :form="form" field="pin"></has-error>
                        </div>

                        <div class="form-group">
                          <label
                            >Contact Email <span class="red">*</span></label
                          >
                          <input
                            v-model="form.email"
                            type="email"
                            name="email"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('email'),
                            }"
                          />
                          <has-error :form="form" field="email"></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Contact Number <span class="red">*</span></label
                          >
                          <input
                            v-model="form.phone"
                            type="text"
                            name="phone"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('phone'),
                            }"
                          />
                          <has-error :form="form" field="phone"></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Landline Number</label
                          >
                          <input
                            v-model="form.landline_no"
                            type="text"
                            name="landline_no"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('landline_no'),
                            }"
                          />
                          <has-error
                            :form="form"
                            field="landline_no"
                          ></has-error>
                        </div>

                        <div class="form-group">
                          <label
                            >GSTIN Number</label
                          >
                          <input
                            v-model="form.gstin"
                            type="text"
                            name="gstin"
                            class="form-control input-sm"
                            :class="{
                              'is-invalid': form.errors.has('gstin'),
                            }"
                          />
                          <has-error
                            :form="form"
                            field="gstin"
                          ></has-error>
                        </div>

                        <div class="form-group">
                          <label>Status <span class="red">*</span></label>

                          <div class="form-check">
                            <input
                              v-model="form.status"
                              value="active"
                              id="customRadio3"
                              class="form-check-input"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                              type="radio"
                              name="status"
                            />
                            <label class="form-check-label" for="customRadio3"
                              >Active</label
                            >
                            <has-error
                              :form="form"
                              field="status"
                            ></has-error>
                          </div>
                          <div class="form-check">
                            <input
                              v-model="form.status"
                              value="inActive"
                              id="customRadio4"
                              class="form-check-input"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                              type="radio"
                              name="status"
                            />
                            <label class="form-check-label" for="customRadio4"
                              >InActive</label
                            >
                            <has-error
                              :form="form"
                              field="status"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
            </div>
            <div class="modal-footer text-center">
              <button
                v-show="!editMode"
                type="submit"
                class="btn btn-success"
              >
                SAVE BRANCH
              </button>
              <button v-show="editMode" type="submit" class="btn btn-success">
                UPDATE BRANCH
              </button>
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <div class="modal fade" id="viewModal">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-aqua">
            
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Branch Details</h4>
          </div>
          <div class="modal-body">
            <!-- right column -->
            <div class="row">
              <div class="col-md-6">
                <!-- Profile Image -->
                <div class="card card-primary card-outline">
                  <div class="card-body box-profile">
                    <ul class="list-group mb-3">
                      <li class="list-group-item">
                        <b>Branch Name</b>

                        <a class="pull-right">{{ form.name }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>Branch Code</b>
                        <a class="pull-right">{{ form.branchCode }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>Opening Date</b>
                        <a class="pull-right">{{ form.openingDate }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>Address</b>
                        <a class="pull-right">{{ form.address }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>City Name</b>
                        <a class="pull-right">{{ form.city }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>State Name</b>
                        <span v-for="stat in states" :key="stat.id">
                          <a
                            class="pull-right"
                            v-if="stat.id == form.state_id"
                            >{{ stat.name }}</a
                          >
                        </span>
                      </li>
                      <li class="list-group-item">
                        <b>Country Name</b>
                        <a class="pull-right">{{ form.country }}</a>
                      </li>
                    </ul>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!-- /.col -->
              <div class="col-md-6">
                <!-- Profile Image -->
                <div class="card card-primary card-outline">
                  <div class="card-body box-profile">
                    <ul class="list-group mb-3">
                      <li class="list-group-item">
                        <b>Pincode</b>
                        <a class="pull-right">{{ form.pin }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>Contact Mail</b>
                        <a class="pull-right">{{ form.email }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>Contact Number</b>
                        <a class="pull-right">{{ form.phone }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>Landline Number</b>
                        <a class="pull-right">{{ form.landline_no }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>GSTIN</b>
                        <a class="pull-right">{{ form.gstin }}</a>
                      </li>
                      <li class="list-group-item">
                        <b>Backdate Entry</b>
                        <a
                          class="pull-right"
                          v-if="form.backDateEntry == '1'"
                          ><span class="label label-success">Yes</span></a
                        >
                        <a class="pull-right" v-else
                          ><span class="label label-danger">No</span></a
                        >
                      </li>
                      <li class="list-group-item">
                        <b>Status</b>
                        <a class="pull-right" v-if="form.status == 'active'"
                          ><span class="label label-success">Active</span></a
                        >
                        <a class="pull-right" v-else
                          ><span class="label label-danger">InActive</span></a
                        >
                      </li>
                    </ul>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!-- /.col -->
            </div>
          </div>
          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CLOSE
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Banch',
  computed: {
    ...mapState([
      'setting'
    ])
  },
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      form: new Form({
        id: '',
        name: '',
        branchCode: '',
        openingDate: new Date().toISOString().slice(0, 10),
        address: '',
        city: '',
        state_id: '',
        country: 'India',
        pin: '',
        email: '',
        phone: '',
        landline_no: '',
        backDateEntry: 'false',
        gstin: '',
        status: ''
      }),
      editMode: false,
      states: {},
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.errors.errors = {}
    },
    viewModal (row) {
      this.editMode = false
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    createBranch () {
      this.$axios
        .post('branch', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Branch Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateBranch () {
      this.$axios
        .put('branch/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Branch Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'branch'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    loadState () {
      this.$axios
        .get('state?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.states = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.changeFilter()
    this.loadState()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// Branches.vue?63f7ae2a